var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage__menu__column"},[_c('router-link',{attrs:{"to":{ name: 'app', params: { section: _vm.homepageItem.page }}}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.homepageItem.title))]),_c('p',[_vm._v(_vm._s(_vm.homepageItem.description))])]),_c('img',{attrs:{"src":_vm.homepageItem.image.src,"alt":_vm.homepageItem.image.alt}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }